import {ValueObject} from '@s-ui/domain'

export class NewsRatingValueObject extends ValueObject {
  /**
   * @param {Object} params
   * @param {String} params.rate
   * @param {String} params.ratesCount
   */
}
